import { securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getStreakCountApi = async (panelListId, credit_points) => {
  return securePost("/api/survey/completeStatus", { panelListId, credit_points });
};